import { render, staticRenderFns } from "./HazardListItem.vue?vue&type=template&id=722e34a9"
import script from "./HazardListItem.vue?vue&type=script&lang=ts"
export * from "./HazardListItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports